import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';

/** `GET /client/:cid/contracts/:id`: 404 when the client is not a party to the contract. */
export const getContract = async (contract_id: string): Promise<any> =>
  lpRequest('GET', clientPath(`/contracts/${contract_id}`));
